'use client';

import React from 'react';


const MenuItem = ({ children,onClick,classnames }: any) => {
    return (
        <>
            <div onClick={onClick} className={classnames || "bg-[#F8F8F8] w-[164px] text-white mx-auto p-[10px] border-b border-[#EEEEEE] cursor-pointer"}>
                {children}
            </div>

        </>
    )
}

export default MenuItem;
